export default __webpack_public_path__ + "static/media/smile.6c2b9c7a.png";